var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.has_role},[(_vm.loading)?_c('div',{staticClass:"text-center"},[_vm._t("loading",function(){return [_c('b-spinner')]})],2):(_vm.has_role)?_vm._t("default"):(!_vm.authorized)?_vm._t("not-authorized",function(){return [_c('h1',[_vm._v("Not authorized")])]}):_vm._t("no-role")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }